var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"show-close":false,"title":"请选择对应部门","width":"50%"},on:{"closed":function($event){return _vm.$emit('update:visible', false)}}},[_c('el-tree',{ref:"tree",attrs:{"props":{
      label: 'organizationName',
      value: 'organizationId',
      children: 'children',
      multiple: true,
    },"data":_vm.organizationOptions,"show-checkbox":""},on:{"check-change":_vm.handleCheckChange}}),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.$emit('update:visible', false)}}},[_vm._v("取消")]),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.handleSubmit}},[_vm._v("确认")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }